export function VolvoIcon(props: React.HTMLAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      xmlSpace="preserve"
      viewBox="0 0 800 110.066"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="#0d3896"
        fillRule="evenodd"
        d="M0 4.723V19.33h23.959l46.887 87.931h57.697l46.887-88.077 23.955-.151.052-14.31h-71.676v14.36h19.088L113.74 81.595 77.933 19.301l26.117-.117-.046-14.461H0zM462.405 4.723V19.33h23.952l46.888 87.931h57.699l46.887-88.077 23.958-.151.043-14.31h-71.663v14.36h19.08l-33.108 62.512-35.811-62.294 26.125-.117-.049-14.461H462.405zM344.515 4.723V19.33h23.955l.04 71.788h-25.255v16.001l25.272.143h119.612v-47.73h-15.581c-.854 25.271-22.776 31.62-32.01 31.62-8.461 0-24.855-.033-24.855-.033V19.301l23.595-.118-.032-14.461h-94.741v.001zM262.808 94.13c-14.355 0-25.986-17.195-25.986-38.417 0-21.227 11.631-38.435 25.986-38.435 14.351 0 25.986 17.208 25.986 38.435 0 21.222-11.635 38.417-25.986 38.417zm1.056-92.353c-40.72 0-73.729 24.247-73.729 54.145 0 29.9 33.008 54.144 73.729 54.144 40.717 0 73.731-24.244 73.731-54.144 0-29.898-33.014-54.145-73.731-54.145zM725.215 93.857c-14.35 0-25.98-17.48-25.98-39.053 0-21.565 11.631-39.049 25.98-39.049 14.352 0 25.98 17.484 25.98 39.049.001 21.572-11.628 39.053-25.98 39.053zM726.276 0c-40.729 0-73.728 24.642-73.728 55.028 0 30.385 32.998 55.022 73.728 55.022C766.99 110.05 800 85.413 800 55.028 800 24.642 766.99 0 726.276 0z"
      />
    </svg>
  )
}
